declare namespace $ {

	export class $mol_icon_rectangle extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=rectangle.view.tree.d.ts.map